import { 
    Gallery1, Gallery2, Gallery3, Gallery4, Gallery5, Gallery6, Gallery7, Gallery8, Gallery9, Gallery10, 
    Gallery11, Gallery12, Gallery13, Gallery14, Gallery15, Gallery16, Gallery17, Gallery18, Gallery19, Gallery20, 
    Gallery21, Gallery22, Gallery23, Gallery24, Gallery25, Gallery26, Gallery27, Gallery28, Gallery29, Gallery30, 
    Gallery31, Gallery32, Gallery33, Gallery34, Gallery35 
} from '../assets';

const GalleryData = [
    { "id": 1, "img": Gallery1, "alt": "Gallery 1" },
    { "id": 2, "img": Gallery2, "alt": "Gallery 2" },
    { "id": 3, "img": Gallery3, "alt": "Gallery 3" },
    { "id": 4, "img": Gallery4, "alt": "Gallery 4" },
    { "id": 5, "img": Gallery5, "alt": "Gallery 5" },
    { "id": 6, "img": Gallery6, "alt": "Gallery 6" },
    { "id": 7, "img": Gallery7, "alt": "Gallery 7" },
    { "id": 8, "img": Gallery8, "alt": "Gallery 8" },
    { "id": 9, "img": Gallery9, "alt": "Gallery 9" },
    { "id": 10, "img": Gallery10, "alt": "Gallery 10" },
    { "id": 11, "img": Gallery11, "alt": "Gallery 11" },
    { "id": 12, "img": Gallery12, "alt": "Gallery 12" },
    { "id": 13, "img": Gallery13, "alt": "Gallery 13" },
    { "id": 14, "img": Gallery14, "alt": "Gallery 14" },
    { "id": 15, "img": Gallery15, "alt": "Gallery 15" },
    { "id": 16, "img": Gallery16, "alt": "Gallery 16" },
    { "id": 17, "img": Gallery17, "alt": "Gallery 17" },
    { "id": 18, "img": Gallery18, "alt": "Gallery 18" },
    { "id": 19, "img": Gallery19, "alt": "Gallery 19" },
    { "id": 20, "img": Gallery20, "alt": "Gallery 20" },
    { "id": 21, "img": Gallery21, "alt": "Gallery 21" },
    { "id": 22, "img": Gallery22, "alt": "Gallery 22" },
    { "id": 23, "img": Gallery23, "alt": "Gallery 23" },
    { "id": 24, "img": Gallery24, "alt": "Gallery 24" },
    { "id": 25, "img": Gallery25, "alt": "Gallery 25" },
    { "id": 26, "img": Gallery26, "alt": "Gallery 26" },
    { "id": 27, "img": Gallery27, "alt": "Gallery 27" },
    { "id": 28, "img": Gallery28, "alt": "Gallery 28" },
    { "id": 29, "img": Gallery29, "alt": "Gallery 29" },
    { "id": 30, "img": Gallery30, "alt": "Gallery 30" },
    { "id": 31, "img": Gallery31, "alt": "Gallery 31" },
    { "id": 32, "img": Gallery32, "alt": "Gallery 32" },
    { "id": 33, "img": Gallery33, "alt": "Gallery 33" },
    { "id": 34, "img": Gallery34, "alt": "Gallery 34" },
    { "id": 35, "img": Gallery35, "alt": "Gallery 35" }
];

export default GalleryData;
